import {
  FilterMode,
  AiSearchPatternCreateMutationVariables,
  AiSearchPattern_OrderBy,
  AiSearchPattern,
  SortOrder,
  AiSearchPattern_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const aiSearchPatternService = {
  createOne: buildCreateOne(
    (aiSearchPatternCreateVariables: AiSearchPatternCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.aiSearchPatternCreate(
          aiSearchPatternCreateVariables
        );
        return result.aiSearchPatternCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.aiSearchPatternOne({ id });
    return result.aiSearchPatternOne as AiSearchPattern;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: AiSearchPattern_OrderBy[] | null = null,
    filter: AiSearchPattern_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: AiSearchPattern_Filter | undefined;
    if (searchValue !== "") {
      where = { name: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.aiSearchPatternListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.aiSearchPatternListWithOffset
    ) as AiSearchPattern[];
    return { list, orderBy };
  },
};
